export const PROFESSIONAL_URL = {
    PUBLIC: '/professional',
    EDIT_MODE: '/professional-preview',
};

export const PROFESSIONAL_DETAILS_BASE_ROUTE_ID = `routes/_app.professional.$urlSegment`;
export const PREVIEW_BASE_ROUTE_ID = `routes/_app.professional-preview.$urlSegment`;
